export const BASE_URL = "https://dev-api.disasterplanning.com"//"https://www.disasterplanning.com";//"https://prod-api.disasterplanning.com";
export const SITE_URL = process.env.VUE_APP_SITE_URL;